import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { last, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/service/auth.service';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { UtilitiesService } from 'src/app/core/service/utilities.service';
import Swal from 'sweetalert2';
import * as _ from "lodash";

@Component({
  selector: 'app-detail-visite-medecin',
  templateUrl: './detail-visite-medecin.component.html',
  styleUrls: ['./detail-visite-medecin.component.scss']
})
export class DetailVisiteMedecinComponent implements OnInit {

  @Input() patientId: string;
  @Input() dossierHospi:any
  @Input() detailToShow:any
  @Output() onSelectCategorieClient: EventEmitter<any> = new EventEmitter();
  @Output() onSelectDatasAssurances: EventEmitter<any> = new EventEmitter();
  user: any = {};
  busyGet: Subscription;
  loading: boolean = false;
  endPoint : string = 'beneficiaire/';
  itemToSave:any={}
  beneficiaireInfo: any={};
  itemsHistoPriseDeConstante: any=[];
  medecinFullName: any;
  beneficiaireInfoAssurance: any;
  itemsCategorie: any;
  itemsAssurances: any[];
  currentAssurance: any;
  listAssurancesToSave: any=[];
  oldAssur: any =[];
  imgUrl: string;
  constructor(private authService: AuthService, private restClient: RestClientService, private modalService: BsModalService, private utilities: UtilitiesService) {
    this.user = this.authService.currentUserValue;
    
  }
  ngAfterViewInit(){
    console.info('dossierHospi',this.dossierHospi);
    
  }
  ngOnChanges(changes: SimpleChanges) {

    if(changes['dossierHospi'] && changes['dossierHospi'].currentValue)
    {
      this.dossierHospi = changes['dossierHospi'].currentValue
      this.itemToSave = this.dossierHospi
      console.info('data passed dossierHospi: ',this.dossierHospi);
      this.itemToSave.noDemande = this.itemToSave.hospiNumeroDemande || this.itemToSave.numeroDemande
      this.itemToSave.dateDossier = this.itemToSave.dateCreationDossier?this.itemToSave.dateCreationDossier:this.itemToSave.dateHospi
      this.itemToSave.patient = this.itemToSave.nomPatient+' '+this.itemToSave.prenomPatient



      this.itemToSave.uniteFoncLibelle = this.itemToSave.uniteFoncLibelle || this.itemToSave.uniteFonctionnelleLibelle
      this.itemToSave.matricule  = this.itemToSave.matricule || this.itemToSave.matriculeBeneficiaire
      this.itemToSave.medecinTraitant = this.itemToSave.medecinTraitant || this.itemToSave.userNom+' '+this.itemToSave.userPrenom
      this.itemToSave.sexe=this.itemToSave.sexe??this.itemToSave.sexePatient

      if(this.dossierHospi.datasAssurance || this.dossierHospi.assurances){
        this.listAssurancesToSave=[...this.dossierHospi.datasAssurance??this.dossierHospi.assurances]
        this.listAssurancesToSave.map(lats=>lats.isOld=true)
        this.oldAssur = [...this.listAssurancesToSave]
        console.info('preselected: ',this.listAssurancesToSave);
      }

      this.imgUrl = this.dossierHospi.imgUrl
      if(!this.imgUrl && this.dossierHospi.matricule){
        this.getInfoBenef(this.dossierHospi.matricule)
      }

      

    }
  }
  

  getDatasCategorieClient() {

    let request = {
      user: this.user.id,
      data: {
        
      },
    }
    console.info('data sent to server',request);
    this.busyGet = this.restClient.post('adminCategorieClient/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.itemsCategorie = res['items']
            console.info('this.itemsCategorie: ',this.itemsCategorie);
            
          }
          else {
            this.itemsCategorie = [];
          }
        },
        err => {
        }
      );
  }


  getHistoPriseDeConstante() {
    
    if(!this.dossierHospi.patientId){
      return
    }
    let request = {
      user: this.user.id,
      data: {
        dossierHospiId: this.dossierHospi.id
      },
    }

    console.info('data sent to server',request);
    
    this.busyGet = this.restClient.post('hospiPriseConstante/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.itemsHistoPriseDeConstante = res['items'];
          }
          else {
            this.itemsHistoPriseDeConstante = [];
          }
        },
        err => {
        }
      );
  }

  onSelectCategorie(){
    this.onSelectCategorieClient.emit(this.itemToSave.categorieClientId)
  }

  onSelectAssaurance(){
    this.onSelectDatasAssurances.emit(this.listAssurancesToSave)
  
  }
  getItemsAssurance(){
    let request = {
      user: this.user.id,
      data: {
      },

    }
    console.info('data sent to server: ',request);
    this.busyGet = this.restClient.post('adminAssurance/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.itemsAssurances = res['items'];
          }
          else {
            this.itemsAssurances = [];
          }
        },
        err => {
        }
      );
  }

  addAssurance() {

    console.info('assurance select: ',this.currentAssurance);
    console.info('all assur: ',this.listAssurancesToSave);
    

    if (!this.currentAssurance) {
      this.utilities.showNotification("snackbar-danger", "Veuillez sélectionner une assurance !",
        "bottom",
        "center");
      return;
    }

    // Verifier si ce acte n'existe pas dans le tableau
    let isExisteAssurance = _.find(this.listAssurancesToSave, (o) => { return (o.id == this.itemToSave?.assuranceSelected?.id || o.id == this.currentAssurance?.id) });

    if (isExisteAssurance) {
      // Dans ce cas l'acte est deja dans le tableau
      this.utilities.showNotification("snackbar-danger", "Cette assurance a déjà été sélectionnée !",
        "bottom",
        "center");
      return;
    }


    this.listAssurancesToSave.push(this?.currentAssurance);
    this.currentAssurance = "";

    // this.getMontantPartAssurance();
  }

  getInfoBenef(matricule:any){
    let request = {
      user: this.user.id,
      data: {
        matriculeBeneficiaire: matricule
    }

    }
    console.info('data sent to server: ',request);
    this.busyGet = this.restClient.post('beneficiaire/getByCriteria', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.imgUrl = res['items'][0].imgUrl;
          }
          else {
            this.imgUrl=null
          }
        },
        err => {
        }
      );
  }

  handleError(){
    this.imgUrl="https://png.pngtree.com/png-vector/20190710/ourmid/pngtree-user-vector-avatar-png-image_1541962.jpg"
  }
  
  ngOnInit() {
    this.getDatasCategorieClient() 
    this.getItemsAssurance()
  }
}
